// Code generated by go run pkg/apigen/generate. DO NOT EDIT.

import useSWR, { SWRConfiguration, SWRResponse } from "swr";

import * as enums from "~src/shared/enums";
import * as routerTypes from "~src/user/apigen/types";
import * as globalTypes from "~src/shared/apigen/types";
import { fetchRPCRoute } from "~src/shared/apigen/framework";
import { FieldValidationError, RPCError, IRPCErrorOptions } from "~src/shared/errors/taxonomy";

export type IUserLeaveRoomReturn = Record<string, never>;

export const userLeaveRoom = async (
): Promise<IUserLeaveRoomReturn> => {
  return await fetchRPCRoute({
    method: "POST",
    router: "user",
    routePath: "LeaveRoom",
    args: undefined,
    errors: [
    ],
  });
};

export const useUserLeaveRoom = (
  config?: SWRConfiguration & {
    // If true, the hook will not fetch. Data will be null.
    blockFetch?: boolean,
    // This value will be included in the cache key. Pass different values to force cache
    // invalidation.
    refetchNonce?: number | string,
  },
): SWRResponse<IUserLeaveRoomReturn, RPCError> => {
  return useSWR(
    config?.blockFetch === true ? null : ["/user/LeaveRoom", config?.refetchNonce],
    userLeaveRoom,
    config,
  );
};
